(() => {
  const root = document.querySelector("[data-gift-scene]");
  if (!root) return;

  const grid = root.querySelector("[data-gift-scene-grid]");
  const cards = [...root.querySelectorAll("[data-gift-scene-card]")];
  const filters = [...root.querySelectorAll("[data-gift-tag]")];
  const empty = root.querySelector("[data-gift-scene-empty]");
  if (!grid || !cards.length || !filters.length) return;

  /** 商品の data-tags（Liquid がカンマ連結）。中黒「・」を含む1タグは分割しない */
  const productTags = (raw) =>
    (raw || "")
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean);

  const allBtn = filters.find((btn) => btn.dataset.giftTag === "all");
  const specific = filters.filter((btn) => btn.dataset.giftTag !== "all");

  const setPressed = (btn, on) => {
    btn.setAttribute("aria-pressed", on ? "true" : "false");
    btn.classList.toggle("is-active", on);
  };

  const selectAll = () => {
    if (allBtn) setPressed(allBtn, true);
    specific.forEach((btn) => setPressed(btn, false));
  };

  const selectOne = (btn) => {
    if (allBtn) setPressed(allBtn, false);
    specific.forEach((item) => setPressed(item, item === btn));
  };

  const apply = () => {
    const allOn = allBtn?.getAttribute("aria-pressed") === "true";
    const active = specific.find((btn) => btn.getAttribute("aria-pressed") === "true");
    const key = active?.dataset.giftTag?.trim() || "";

    let shown = 0;
    cards.forEach((card) => {
      const cardTags = productTags(card.dataset.tags);
      const show = allOn || (key !== "" && cardTags.includes(key));
      card.hidden = !show;
      if (show) shown += 1;
    });
    if (empty) empty.hidden = shown > 0;
  };

  filters.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (btn.dataset.giftTag === "all") {
        selectAll();
        apply();
        return;
      }

      if (btn.getAttribute("aria-pressed") === "true") {
        selectAll();
        apply();
        return;
      }

      selectOne(btn);
      apply();
    });
  });

  apply();
})();
